import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
  template: z.string().optional(),
  prompt: z.string().optional(),
})

export const Route = createFileRoute('/_protected/studio/build')({
  validateSearch: searchSchema,
  component: lazyRouteComponent(
    () => import('@/pages/studio-mock/build-page/page'),
    'StudioBuildPage',
  ),
})
